import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgPayPalColored({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M8.33 20.299l.311-1.969-.686-.012H4.64L6.932 3.761c.013-.039.026-.09.065-.116a.46.46 0 01.116-.052h5.569c1.851 0 3.12.388 3.794 1.14.298.323.505.712.608 1.139a3.989 3.989 0 010 1.567l-.012.039v.401l.31.168c.233.117.454.285.635.48.285.323.453.725.518 1.152a4.53 4.53 0 01-.078 1.67 5.821 5.821 0 01-.686 1.891 3.83 3.83 0 01-1.088 1.192c-.44.31-.932.53-1.463.66a7.179 7.179 0 01-1.826.207h-.428c-.647 0-1.19.466-1.294 1.1l-.026.182-.544 3.47-.026.13c0 .026-.013.052-.039.078a.097.097 0 01-.052.026l-2.654.013z"
        fill="#253B80"
      />
      <path
        d="M17.693 7.543c-.013.104-.039.22-.052.324-.738 3.769-3.25 5.077-6.449 5.077H9.548a.805.805 0 00-.79.673l-.842 5.31-.233 1.501a.414.414 0 00.35.48h2.965a.695.695 0 00.686-.583l.026-.143.544-3.457.039-.195a.707.707 0 01.686-.595h.428c2.81 0 5.011-1.14 5.646-4.442.272-1.373.13-2.525-.583-3.34a2.574 2.574 0 00-.777-.61z"
        fill="#179BD7"
      />
      <path
        d="M16.929 7.246c-.116-.039-.233-.065-.35-.09a8.948 8.948 0 00-1.8-.168h-4.377a.685.685 0 00-.686.582l-.932 5.879-.026.168a.795.795 0 01.79-.673h1.631c3.212 0 5.724-1.308 6.462-5.077.026-.116.04-.22.052-.323a3.525 3.525 0 00-.609-.246l-.155-.052z"
        fill="#222D65"
      />
      <path
        d="M9.716 7.57a.695.695 0 01.686-.583h4.364c.48 0 .959.026 1.438.103.13.026.246.04.362.065.117.026.233.052.35.09l.168.053c.208.064.415.155.609.259.22-1.399 0-2.344-.751-3.199-.829-.945-2.331-1.347-4.248-1.347h-5.58a.792.792 0 00-.778.674l-2.33 14.684a.48.48 0 00.4.544H7.93l.868-5.477.919-5.867z"
        fill="#253B80"
      />
    </svg>
  )
}

export default SvgPayPalColored
